import ApiBase from './Base'

function* getPasswordRequirements() {
  return yield ApiBase.privateGet('/v1/users/profile_info/')
}

export default { getPasswordRequirements }
